// extracted by mini-css-extract-plugin
module.exports = {"orderDetail":"style-module_orderDetail_1bE-D"};